/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageViewGrid/view.blocks to change it.
import ImageGrid from './ImageGrid/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageViewGrid({
  children,
  viewPath = "/DesignSystem/ImageViewGrid",
  contentRef,
  onImageAnalyze
  
}) {
  return (<React.Fragment
>
<div
  data-testid="ImageViewGrid.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 className={`views-block ${styles.Vertical}`}
>
<ImageGrid
  viewPath={`${viewPath}/ImageGrid`}
 onImageAnalyze={onImageAnalyze}
/>
</div>
{children}
</React.Fragment>)
}